import { useHistory } from 'react-router-dom';

import { useCreateBeraRevision } from '@/hooks';
import { BERA_REPORT_PATH } from '@/views/Bera/constants';
import { useApplicationContext } from '@/context/v1/Application/context';

import type { BeraJobSummaryListItem, BeraRevisionOverrides, BeraRevisionType } from '@/types/Bera';

interface StartBeraRevisionParams {
	report: Pick<BeraJobSummaryListItem, 'id'>;
	overrides?: BeraRevisionOverrides;
	onSuccess: () => void;
}

type StartBeraRevisionResult = {
	isLoading: boolean;
	startRevision: (revisionType: BeraRevisionType) => void;
};

export function useStartBeraRevision({
	report,
	overrides,
	onSuccess
}: StartBeraRevisionParams): StartBeraRevisionResult {
	const history = useHistory();
	const { organization, company } = useApplicationContext();
	const { mutate: createRevision, isLoading } = useCreateBeraRevision();

	function startRevision(revisionType: BeraRevisionType): void {
		const payload = {
			...overrides,
			id: report.id,
			organization_id: organization?.id,
			company_id: company?.id,
			revision_type: revisionType
		};

		createRevision(payload, {
			onSuccess: (revision) => {
				onSuccess();
				history.push(`${BERA_REPORT_PATH}/${revision.id}?revision=${revisionType.toLowerCase()}`);
			}
		});
	}

	const result = { isLoading, startRevision };

	return result;
}
